import React from 'react';
import { successAlert, dangerAlert, attentionAlert, infoAlert } from '../components/Alert';

const messageTypes = { 
	success: successAlert,
	danger: dangerAlert,
	attention: attentionAlert,
	info: infoAlert 
};

const MESSAGE_TIMEOUT_SECONDS = 5;

let showTemporaryMessage;

const Message = () => {
	const [messages, setMessages] = React.useState([]);

	showTemporaryMessage = (
			title,
			messageText,
			messageType = 'success',
			duration = MESSAGE_TIMEOUT_SECONDS
		) => {
		const id = Date.now();
		const newMessage = {
			id,
			title,
			text: messageText,
			type: messageType,
			display: true
		};
		setMessages((prevMessages) => [...prevMessages, newMessage]);
		setTimeout(() => {
				setMessages((prevMessages) =>
				prevMessages.filter((message) => message.id !== id)
			);
		}, duration * 1000);
	};

	const removeMessage = (id) => {
		setMessages((prevMessages) =>
			prevMessages.filter((message) => message.id !== id)
		);
	};

	if (messages.length === 0) return null;
	return (
		<div className="fixed top-4 left-4 z-50">
			{messages.map((message) => {
				const messageConfig = messageTypes[message.type] || messageTypes.info;
				return (
					<div
						key={message.id}
						className={`relative p-4 rounded-md shadow-lg ${messageConfig.backgroundColor} max-w-sm`}
					>
					<div className="flex items-center">
						{/* Message icon */}
						{messageConfig.icon}
						{/* Message title */}
						<p className={`text-base font-bold uppercase pl-1 ${messageConfig.textColor}`}>
							{message.title}
						</p>
					</div>
					{/* Message text */}
					<p className={`ml-7 text-sm ${messageConfig.textColor}`}>
						{message.text}
					</p>
					<button
						onClick={() => {removeMessage(message.id)}}
						className="absolute top-1 right-2 text-lg font-bold">
						&times;
					</button>
				</div>
				);
			})}
		</div>
	);
};

export { showTemporaryMessage, Message, messageTypes };
